<template>
  <b-container
    fluid
    class="position-relative d-flex flex-row align-items-center justify-content-center p-2"
  >
    <div class="flex-grow-1">
      <router-link class="display-6" to="/">DuMILi</router-link>
      <div class="small">DUcksManager Inducks LIttle helper</div>
      <div v-if="!isSocketConnected" class="ms-2 text-danger">
        {{ $t("(hors-ligne)") }}
      </div>
    </div>
    <div><SwitchLocale /></div>
  </b-container>

  <b-container
    fluid
    class="d-flex flex-column flex-grow-1 overflow-y-auto justify-content-center"
  >
    <router-view v-if="isSocketConnected" />

    <h4 v-else>
      {{ $t("Dumili est actuellement hors-ligne :-(") }}
    </h4>
  </b-container>
</template>

<script setup lang="ts">
import SwitchLocale from "~web/src/components/SwitchLocale.vue";
import Cookies from "js-cookie";

import useDmSocket, {
  socketInjectionKey as dmSocketInjectionKey,
  webCacheStorage,
} from "~web/src/composables/useDmSocket";

import useDumiliSocket, {
  dumiliSocketInjectionKey,
} from "./composables/useDumiliSocket";

const { t: $t } = useI18n();

const session = {
  getToken: () => Promise.resolve(Cookies.get("token")),
  clearSession: () => {}, // Promise.resolve(Cookies.remove("token")),
  sessionExists: () =>
    Promise.resolve(typeof Cookies.get("token") === "string"),
};

const onConnectError = (e: Error) => {
  const error = String(e);
  console.error(error);
  if (
    error.indexOf("No token provided") !== -1 ||
    error.indexOf("jwt expired") !== -1
  ) {
    session.clearSession();
    isLoadingUser.value = false;
    user.value = undefined;
  }
};

const dumiliSocket = useDumiliSocket({
  session,
  onConnectError,
});

const isSocketConnected = computed(() => !!dumiliSocket.statusSocket.value);

getCurrentInstance()!.appContext.app.provide(
  dumiliSocketInjectionKey,
  dumiliSocket,
);

getCurrentInstance()!.appContext.app.provide(
  dmSocketInjectionKey,
  useDmSocket({
    cacheStorage: webCacheStorage(sessionStorage),
    session,
    onConnectError,
  }),
);

const { isLoadingUser, user } = storeToRefs(collection());
const { loadUser } = collection();

watch(
  isSocketConnected,
  (value) => {
    if (value) {
      loadUser();
    }
  },
  { immediate: true },
);
</script>
<style lang="scss">
@use "./style.scss";
@import "vue-draggable-resizable/style.css";

:deep(#flags) {
  right: 0 !important;
}
</style>
